import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_vm.addAnnouncement ? _c('settings-announcement-edit', {
    ref: "announcementEditor",
    attrs: {
      "maintenance": _vm.maintenance
    },
    on: {
      "cancel-edit": _vm.closeDialog,
      "save": _vm.saveAnnouncement,
      "fetchAllSystemAnnouncements": _vm.fetchAllSystemAnnouncements
    }
  }) : _vm._e(), _c(VForm, {
    ref: "mainForm",
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('accMgmt.announcement.headline'),
      "subtitle": _vm.$i18n_t('accMgmt.announcement.titleInfo'),
      "formIsValid": _vm.formIsValid
    }
  }), _c('div', {
    staticClass: "n20-mainrow"
  }, [_c('core-n20Card', {
    staticClass: "mb-4 mt-4",
    attrs: {
      "buttons": _vm.buttons
    },
    on: {
      "add": function ($event) {
        _vm.addAnnouncement = true;
      }
    }
  }, [_c(VRow, {
    staticClass: "px-4 mb-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c('p', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.announcement.helptext')))]), _c(VCol, {
    staticClass: "pt-1 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "xs": "12",
      "sm": "12"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.tenants,
      "color": _vm.color,
      "value": _vm.selectedTenantId,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    on: {
      "input": _vm.selectTenant
    }
  })], 1)], 1)], 1)], 1), _c('h4', {
    staticClass: "px-4"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.announcement.activeAnnouncements')))]), _c(VCardTitle, {
    staticClass: "pt-2 px-4"
  }, [_vm.announcements.length > 0 ? _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.announcement.searchForAnnouncements'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "single-line": "",
      "hide-details": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.announcementSearch,
      callback: function ($$v) {
        _vm.announcementSearch = $$v;
      },
      expression: "announcementSearch"
    }
  }) : _vm._e()], 1), _c('settings-announcement-table', {
    attrs: {
      "loading": _vm.tableLoading,
      "maintenance": _vm.announcements,
      "searchTerm": _vm.announcementSearch
    },
    on: {
      "openEditDialog": _vm.openEditDialog,
      "deleteAnnouncement": _vm.deleteAnnouncement
    }
  })], 1), _c('br'), _c('br')], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };